import { message as EeveeMessage } from '@fuxi/eevee-ui';
import { getNormalParams, FastApiAxiosInstance } from 'common/service/axiosInstances';
import { Comment, CommentSourceType } from '@/types';

// 从反馈富文本中解析被 @ 提及的用户 id（@ 提及节点由 @wangeditor/plugin-mention 生成）
const extractMentionedUserIds = (content?: unknown): number[] => {
  if (typeof content !== 'string' || !content) return [];
  try {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const nodes = doc.querySelectorAll('span[data-w-e-type="mention"]');
    const ids = new Set<number>();
    nodes.forEach((el) => {
      const info = el.getAttribute('data-info');
      if (!info) return;
      try {
        const parsed = JSON.parse(decodeURIComponent(info));
        if (parsed && parsed.id != null && !Number.isNaN(Number(parsed.id))) {
          ids.add(Number(parsed.id));
        }
      } catch (e) {
        // 忽略无法解析的 info
      }
    });
    return Array.from(ids);
  } catch (e) {
    return [];
  }
};

const comments = {
  getReviews: async (
    taskId: number | string,
    versionId?: number | string,
    orderBy?: 'time' | 'frame',
    filterBy?: string,
  ) => {
    const params = { taskId, versionId, orderBy, filterBy };
    const {
      data: { reviewList = [] },
    } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v2/review/getReviews', {
      params,
    });
    return reviewList;
  },
  getHtmlReviews: async (taskId, versionId) => {
    const params = { ...getNormalParams('getHtmlReviews'), taskId, versionId };
    const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/review/getHtmlReviews', {
      params,
    });
    return data;
  },
  deleteReview: async reviewId => {
    const { code, message } = await FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v1/review/deleteReview', {
      ...getNormalParams('deleteReview'),
      reviewId,
    });
    const hasError = code !== 0;
    if (hasError) {
      EeveeMessage.error(message || '删除反馈失败');
    } else {
      EeveeMessage.success('成功');
    }
    return code === 0;
  },
  addReview: async (versionFileId: number, taskId: number, comment: Partial<Comment>, type?: CommentSourceType) => {
    const formattedComment = {
      taskId: Number(taskId),
      versionFileId: Number(versionFileId),
      preview: comment.preview,
      type, // 注释反馈 or 画板反馈
      content: comment.content,
      annotation: JSON.stringify(comment.annotation),
      attachment: comment.attachment,
      assetPosition: JSON.stringify(comment.assetPosition),
      mentionedUserIds: extractMentionedUserIds(comment.content),
    };
    return FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v2/review/addReview', formattedComment);
  },
  updateReview: async (params: { taskId: number; reviewId: number; comment: Partial<Comment> }) => {
    const { taskId, reviewId, comment } = params;
    const type = comment.type;
    const formattedComment = {
      taskId: Number(taskId),
      preview: comment.preview || {},
      type, // 注释反馈 or 画板反馈
      content: comment.content,
      annotation: JSON.stringify(comment.annotation),
      attachment: comment.attachment,
      assetPosition: JSON.stringify(comment.assetPosition),
      reviewId,
    };
    return FastApiAxiosInstance.post<any, ExtendAxioResponse<any>>('/api/v2/review/updateReview', {
      ...formattedComment,
    });
  },
};

export default comments;
